import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.99967 5V15M9.99967 5L5.83301 9.16667M9.99967 5L14.1663 9.16667",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgArrowUp;
